import cn from 'classnames'
import { Link } from 'react-router-dom'

import { PricingProps } from './Pricing.types'

export const Pricing = (props: PricingProps) => {
    const { className } = props

    const features = [
        'Mathematical Accuracy',
        'Internal Consistency',
        'Prior Year Consistency',
        'External Consistency',
        'Nexly AI',
        'SumSelect',
        'Split Screen',
        'Note Library',
        'Automated Audit Checklist',
        'AI Assistant',
    ]

    return (
        <section className={cn('py-20 bg-gray-50', className)} id='pricing'>
            <div className='container mx-auto px-4'>
                <h2 className='text-4xl font-bold text-center mb-16'>Pricing built for businesses of all sizes</h2>
                <div className='max-w-lg mx-auto bg-white p-8 border rounded shadow-sm'>
                    <div className='text-center'>
                        <div className='text-lg font-semibold'>Enterprise</div>
                        <div className='flex items-center justify-center mt-2'>
                            <div className='mr-1 text-5xl font-bold'>Custom</div>
                        </div>
                        <ul className='mt-10 space-y-3 mb-6 text-left mx-auto max-w-sm'>
                            {features.map((feature) => (
                                <li key={feature} className='flex items-start'>
                                    <span className='text-success mr-3 text-lg'>✓</span>
                                    <span className='text-gray-700'>{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <Link to='/contacts' className='inline-flex items-center justify-center w-full h-12 px-6 mt-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-primary hover:bg-primary-hover focus:shadow-outline focus:outline-none'>
                            Get Started
                        </Link>
                        <p className='max-w-xs mt-6 text-xs text-gray-600 sm:text-sm sm:text-center sm:max-w-sm sm:mx-auto'>
                            For SME and large enterprise. Schedule a demo to receive a tailored quote for your firm.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}
